import React from "react";
import StartView from "./Start";

const StartSignUp = () => <StartView initialMode="signup" />;

export default StartSignUp;
